import { ca } from '@cian/analytics';

import { TNewbuildingBrokerFlatBannerButtonType } from 'shared/components/NewbuildingBrokerFlatBanner';

type TAnalyticsButtonType = 'match' | 'dismatch';

const BUTTON_TYPE_TO_ANALYTICS_TYPE: Record<TNewbuildingBrokerFlatBannerButtonType, TAnalyticsButtonType> = {
  similar: 'match',
  notSimilar: 'dismatch',
};

export const trackFlatBannerClick = (buttonType: TNewbuildingBrokerFlatBannerButtonType) => {
  const extra: Record<TAnalyticsButtonType, boolean> = {
    match: false,
    dismatch: false,
  };

  const analyticsButtonType = BUTTON_TYPE_TO_ANALYTICS_TYPE[buttonType];
  extra[analyticsButtonType] = true;

  ca('eventSite', {
    name: 'oldevent',
    action: 'Click_sopr',
    category: 'Сard',
    label: 'questionnaire_banner',
    useLastProducts: true,
    page: {
      extra,
    },
  });
};
